import MetaHead from "components/base/MetaHead";
import Text from "components/base/Text";
import HeroHeader from "components/sections/HeroHeader";
import MainContainer from "components/sections/MainContainer";
import Trans from "components/base/Trans";
import IframeResizer from "iframe-resizer-react";

import {
  MotionContainer as Container,
  MotionGrid as Grid,
  MotionGridItem as GridItem,
  MotionBox as Box,
  staggeredAppear,
  appearBelow,
} from "utils/motion";

export default function Post() {
  return (
    <MainContainer
      footerSmall
      initialized
      navStyle={{ gradient: false, inverted: false }}
      bg="black.700"
    >
      <MetaHead
        title="LBL_CAREERS_META_TITLE"
        description="LBL_CAREERS_META_DESC"
        imageUrl="/images/meta/careers.jpg"
      />
      <HeroHeader
        imageSrc={{
          base: "/images/careers/header-mobile.jpg",
          md: "/images/careers/header.jpg",
        }}
        alt="HX50 Heliport - Hill Helicopters"
        title={<Trans id="LBL_CAREERS_TITLE" />}
        align="flex-end"
        minHeight={["40vh", null, "600px"]}
        height={["40vh", null, "70vh"]}
        imageProps={{ objectPosition: "top" }}
        noScrollHint
      />
      <Container initial="hidden" animate="visible" variants={staggeredAppear}>
        <Grid
          variants={appearBelow}
          templateColumns={["repeat(2, 1fr)", null, "repeat(3, 1fr)"]}
        >
          <GridItem colSpan={1} />
          <GridItem colSpan={2}>
            <Text
              type="headline_md"
              color="white"
              variants={appearBelow}
              mb="xs"
            >
              <Trans id="LBL_CAREERS_INFO_TITLE" />
            </Text>
            <Text type="p_md" color="white" variants={appearBelow}>
              <Trans id="LBL_CAREERS_INFO_SUBTITLE" />
            </Text>
          </GridItem>
        </Grid>
      </Container>
      <Container
        initial="hidden"
        animate="visible"
        pt={0}
        variants={staggeredAppear}
      >
        <Text type="headline_md" color="white" variants={appearBelow} mb="md">
          <Trans id="LBL_CAREERS_SUBTITLE" />
        </Text>
        <Box h="2px" bg="gray.800" w="100%" />
        <IframeResizer
          id="scout_iframe"
          style={{ width: "100%", height: "100%" }}
          src="https://hill-helicopters.applynow.net.au/"
          title="scout_iframe"
        />
      </Container>
    </MainContainer>
  );
}

